import React from 'react';

const AdditionalInfo = ({ shiftWorkReady, legalIssues, setShiftWorkReady, setLegalIssues }) => {
  return (
    <table style={{ marginTop: '-1px' }}>
      <tbody>
        <tr>
          <th colSpan="2" className="bg">
            <p className="center b">Дополнительные сведения</p>
          </th>
        </tr>
        <tr>
          <td width="70%"><p className="b">Готовность к вахтовому режиму работы?</p></td>
          <td width="30%"><p>{shiftWorkReady ? 'Да' : 'Нет'}</p></td>
        </tr>
        <tr>
          <td><p className="b">Привлекались ли Вы к административной или уголовной ответственности?</p></td>
          <td><p>{legalIssues ? 'Да' : 'Нет'}</p></td>
        </tr>
      </tbody>
    </table>
  );
};

export default AdditionalInfo;
